module.exports = __webpack_public_path__ + "img/taobao.56fb0a34.jpg";